import React, { useState } from "react";
import { FaClipboardList } from "react-icons/fa";
import {
  Flex,
  Text,
  Tabs,
  Drawer,
} from "@mantine/core";
import { IoMdSend } from "react-icons/io";
import { PushNotificationRecord } from "../models/PushNotificationRecord";
import { useDisclosure } from "@mantine/hooks";
import { PushNotificationDrawer } from "../components/PushNotificationDrawer";
import { PushNotificationRecordsTab } from "../components/PushNotificationRecordsTab";
import { SendPushNotificationsTab } from "../components/SendPushNotificationsTab";

const PushNotifications = () => {
  const [createDrawerOpened, createDrawerHandlers] = useDisclosure(false);
  const [selectedRecord, setSelectedRecord] = useState<PushNotificationRecord | null>(null);

  return (
    <>
      <Drawer
        offset={8}
        radius="md"
        position="left"
        opened={createDrawerOpened}
        onClose={() => {
          createDrawerHandlers.close();
        }}
      >
        <PushNotificationDrawer selectedRecord={selectedRecord}/>
      </Drawer>

      <Tabs defaultValue="send">
        <Flex justify="center">
          <Tabs.List>
            <Tabs.Tab value="records" leftSection={<FaClipboardList size={18} />}>
              <Text size="md" fw={500}>Push Notification Records</Text>
            </Tabs.Tab>
            <Tabs.Tab value="send" leftSection={<IoMdSend size={18} />}>
              <Text size="md" fw={500}>Send Push Notifications</Text>
            </Tabs.Tab>
          </Tabs.List>
        </Flex>

        <Tabs.Panel value="records">
          <PushNotificationRecordsTab setSelectedRecord={setSelectedRecord} openDrawer={createDrawerHandlers.open}/>
        </Tabs.Panel>

        <Tabs.Panel value="send">
          <SendPushNotificationsTab />
        </Tabs.Panel>
      </Tabs>
    </>
  );
};

export default PushNotifications;
